import { Footer } from "@nju/feature-portal-footer";
import { Header } from "@nju/feature-portal-header";
import { SelectNewOrExistingNumberPage } from "@nju/feature-portal-msisdn";
import { RespectOrchestratorState } from "@nju/feature-portal-orchestrator";
import { BlockContent, LayoutWrapper } from "@nju/ui";
import { ClientSideOnly } from "../components/ClientSideRenderer";

export default function ChooseNumber() {
  return (
    <LayoutWrapper>
      <Header />
      <BlockContent>
        <ClientSideOnly>
          <RespectOrchestratorState
            mode={["mobile", "postpaid"]}
            state="ITEM_SELECTION"
          >
            <SelectNewOrExistingNumberPage />
          </RespectOrchestratorState>
        </ClientSideOnly>
      </BlockContent>
      <Footer />
    </LayoutWrapper>
  );
}
